import { makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import DbTasks from '../../db/DbTasks';
import { getBeraterId } from '../../helpers/HelperFunctions';
import BackdropSpinner from '../Reusable/BackdropSpinner';
import {getDataFromDatabase} from '../../db/api';
import moment from 'moment';

//Custom CSS modules
import "../../css/FirmenInfo.css";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        margin: theme.spacing(2),
    },
    allgemein:{
        // backgroundColor: 'red',  
        margin: '5px',
        marginTop: '0px',
        borderTop: '1px solid #1976d2',
        textAlign: 'center',
        display: 'block'
        //display: 'none'       
    },
    allgemeinCustom: {
        margin: '5px',
        marginTop: '0px',
        //borderTop: '1px solid #1976d2',
        textAlign: 'right',
        display: 'block'
    },
    allgemeinNoContent: {
        display: 'none'
    }
}));

function Allgemein() {
    const classes = useStyles();
    const [showLoading, setLoading] = useState(true);
    const [showContent, setShowContent] = useState(false);
    const [items, setItems] = useState([]);

    useEffect(() => {
        let beraterId = getBeraterId();
        getDataFromDatabase(`api/FirmaInfo/Veranstaltungen`, { BeraterId: beraterId, Type: 1 }, { method: "POST" })
            .then(res => {
                // console.log(res);
                if (!res) {
                    setLoading(false);
                    return;
                } else {
                        res.sort((a, b) => {
                            return a.sortOrder - b.sortOrder;
                        });
                        setLoading(false);
                        if (res.length > 0) setShowContent(true);

                        const processed = res.map(item => {
                            let newBody = item.body || "";
                            const imgMatch = newBody.match(/<img[^>]*>/i);
                            if (imgMatch) {
                                const img = imgMatch[0];
                                const replacedImgStyle = img.replace(/style="[^"]*"/i, "class='img-event'");
                                newBody = newBody.replace(img, replacedImgStyle);
                            }

                            return {
                                ...item,
                                processedBody: newBody,
                                displayDate: item.modifiedDate ? moment(item.modifiedDate).format("DD.MM.YYYY") : ""
                            };
                        });

                        setItems(processed);
                }
            })
        return () => {
            console.log("Running cleanup function !");
        }
    }, [])
    return (
        <div className={classes.root}>
            Allgemein

            {items.map((item, index) => (
                <React.Fragment key={item.id || index}>
                    <div className={classes.modifiedDate}>
                        <span className={showContent ? classes.allgemeinCustom : classes.allgemeinNoContent}>{item.displayDate}</span>
                    </div>

                    <div className={showContent ? classes.allgemein : classes.allgemeinNoContent} dangerouslySetInnerHTML={{ __html: item.processedBody }} />
                </React.Fragment>
            ))}
            
            <BackdropSpinner showLoading={showLoading} />
        </div>
    )
}

export default withRouter(Allgemein);